import React from "react";
import styled from "styled-components";
import { imgText } from "../Views/Cameras/imgText";
import storageService from "../../../services/storageService";

const DEFAULT_IMG = "images/320x180_blank.gif";

const StyledSection = styled.section`
  position: relative;
  width: 320px;
  height: 180px;
  flex-shrink: 0;

  img.cameraFeed {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    z-index: 1050;
  }
  img.heatOverlay {
    z-index: 1090;
    opacity: 0.4;
    /* opacity: 1; */
    border-radius: 5px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 320px;
    height: 180px;
  }
`;

export interface CameraImageProps {
  handleImageClick: ()=> void;
  showHeatmap: boolean;
  image: string;
  heatmap: string;
}

//Layout is determined here
const CameraImage: React.FC<CameraImageProps> = props => {
  const { image, heatmap } = props;
  const imageSrc = image ? storageService.signURL(image) : DEFAULT_IMG;
  const heatmapSrc = heatmap ? storageService.signURL(heatmap) : DEFAULT_IMG;
  return (
    <>
      <StyledSection onClick={props.handleImageClick}>
        <img className="cameraFeed" src={imageSrc}></img>
        {props.showHeatmap && (
          <img className="heatOverlay" src={heatmapSrc}></img>
        )}
      </StyledSection>
    </>
  );
};

export default CameraImage;
